<template lang="pug">
.step-resumen
  b-row
    // Despacho
    b-col(md="6")
      b-form-group(label="Tipo de Despacho" label-for="despacho")
        b-form-select#despacho(
          v-model="form.despacho_tipo"
          :options="despachoOptions"
          @change="onDispatchChange"
        )

      .mt-3(v-if="form.despacho_tipo === 'envio'")
        b-form-group(label="Dirección de Envío" label-for="direccion-envio")
          b-form-input#direccion-envio(
            v-model="form.direccion_envio"
            placeholder="Ingrese dirección de envío"
          )
        b-form-group(label="Costo de Envío (IVA incluido)" label-for="costo-envio" class="mt-3")
          b-input-group(prepend="$")
            b-form-input#costo-envio(
              v-model.number="form.costo_envio"
              type="number"
              min="0"
              placeholder="0"
              @input="$emit('update-totals')"
            )

  // Totales
  .totals-section.mt-4
    .total-list
      .total-item
        span.label Sub Total (neto)
        span.value {{ totals.subtotal | formatCurrency }}
      .total-item
        span.label Descuento (neto)
        span.value.text-danger -{{ totals.descuento | formatCurrency }}
      .total-item
        span.label IVA (19%)
        span.value {{ totals.iva | formatCurrency }}
      .total-item
        span.label Embalaje y Envío (IVA incl.)
        span.value {{ totals.envio | formatCurrency }}
      .total-item.grand-total
        span.label Total
        span.value {{ totals.total | formatCurrency }}

  .confirm-section.mt-4.d-flex.justify-content-end
    b-button.btn-generate-quote(
      @click="$emit('confirm')"
      :disabled="loading"
    )
      b-spinner(small v-if="loading")
      span(v-else) Generar Cotización
</template>

<script>
export default {
  name: 'Step3Resumen',
  props: {
    form: {
      type: Object,
      required: true,
    },
    totals: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      despachoOptions: [
        { text: 'Seleccione', value: null },
        { text: 'Retiro en Tienda', value: 'retiro' },
        { text: 'Envío a Domicilio', value: 'envio' },
      ],
    }
  },
  methods: {
    onDispatchChange() {
      this.$emit('update-totals')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.step-resumen {
  .total-list {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .total-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 0;
      color: #525252;

      .label {
        font-weight: bold;
        font-size: 18px;
      }

      .value {
        font-size: 15px;
      }

      &.grand-total {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #ddd;
        color: #23201c;

        .label,
        .value {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
  }

  .btn-generate-quote {
    background-color: #fece2f;
    color: #23201c;
    border: none;
    border-radius: 8px;
    height: 45px;
    padding: 0 30px;
    font-weight: bold;

    &:hover {
      background-color: #f4c235;
    }
  }

  ::v-deep .form-group label {
    font-weight: bold;
    color: #23201c;
    font-size: 15px;
  }

  ::v-deep .form-control,
  ::v-deep .custom-select {
    height: 45px;
    border: 1px solid #525252;
    border-radius: 5px;
  }
}
</style>
